"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function Composition24Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 47, height: 20, viewBox: "0 0 47 20" }, props),
        react_1.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("g", { fill: "#383F49", fillRule: "nonzero" },
                react_1.default.createElement("g", null,
                    react_1.default.createElement("g", null,
                        react_1.default.createElement("g", null,
                            react_1.default.createElement("path", { d: "M22 0l-.015 20H1.288c-.214 0-.423-.064-.6-.185-.487-.331-.613-.994-.281-1.48l5.089-7.477c.087-.136.2-.253.335-.345.509-.348 1.183-.247 1.574.2l1.996 1.837 3.604-5.246c.088-.138.203-.257.34-.35.56-.38 1.32-.218 1.682.35.263.415.559.87.968 1.495l.052.079.417.635.177.269.43.655.311.478c.532.818.964 1.498 1.346 2.123l-1.707 1.043c-.37-.607-.793-1.273-1.315-2.076-.098-.15-.2-.307-.31-.473-.087-.134-.252-.387-.428-.654l-.176-.268-.469-.714-.328-.502-4.252 6.19-3.102-2.855L3.053 18h16.934l.012-16H2v8.227H0V0h22zm18 15v2H27v-2h13zm7-4v2H27v-2h20zM6.983 3c1.649 0 2.983 1.345 2.983 3S8.632 9 6.983 9C5.333 9 4 7.655 4 6s1.333-3 2.983-3zM47 7v2H27V7h20zM6.983 5C6.442 5 6 5.446 6 6s.442 1 .983 1c.54 0 .983-.446.983-1s-.442-1-.983-1zM47 3v2H27V3h20z", transform: "translate(-309 -314) translate(123 199) translate(169 98) translate(17 17)" })))))));
}
function Composition24(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(Composition24Svg, Object.assign({}, svgProps)));
}
exports.default = Composition24;
//# sourceMappingURL=Composition24.js.map